import type { FaireProductEntity } from "../../entity_types/product";

export const p_bzspsx8bmy: FaireProductEntity = {
  token: "p_bzspsx8bmy",
  type: "product",
  name: "Linen Hardcover A5 Journal | Neutral Tones Notebook",
  brandName: "Studio Portmanteau",
  imageUrl:
    "https://cdn.faire.com/fastly/d0b6ec7ab9cc22b12d8fac22ebda5c14ad7afa5e9e835e404fdefc06294bfe90.jpeg",
  priceDollars: 8,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/b235fcd337bd810e835642f511463edbc6d1230fb2b3e52e5291e240cd9ef06a.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
